// extracted by mini-css-extract-plugin
export default {"popupBackground":"CouponLoginScreen_popupBackground__rF1mX","parentDiv":"CouponLoginScreen_parentDiv__Isree","banner":"CouponLoginScreen_banner__Y-u78"};